import { useCallback } from 'react'
import { Button, Dialog, Text } from '@/ui'
import { ONBOARDING_V2_ROUTE_NAMES, OnboardingTaskIdents } from '../config'
import { UploadPrevMonthStatementStatus } from '@/features/user/dashboard/lib/userActionItemStatuses'
import { markUserActionItemCompleteIfExists } from '@/features/user/dashboard/lib/service'
import { useAnalyticsTrack } from '@/features/amplitude'
import { useNavigate } from 'react-router-dom'

export const SkipUploadStatementsModal = ({
  closeModal,
}: {
  closeModal: () => void
}) => {
  const track = useAnalyticsTrack()
  const navigate = useNavigate()

  const handleSkipClick = useCallback(async () => {
    track('completed onboarding item upload statements', { status: 'skipped' })
    await markUserActionItemCompleteIfExists(
      OnboardingTaskIdents.UPLOAD_PREV_MONTH_STATEMENTS,
      track,
      UploadPrevMonthStatementStatus.skipped
    )
    navigate(ONBOARDING_V2_ROUTE_NAMES.ONBOARDING_COMPLETE)
  }, [track, navigate])

  const handleCancelClick = () => {
    track('cancelled skip upload statements')
    closeModal()
  }

  return (
    <Dialog open onClose={handleCancelClick}>
      <Dialog.Title>Are you sure you want to skip?</Dialog.Title>
      <Dialog.Description className="p-4">
        <Text>
          Without your bank statements, we won’t be able to get the full picture
          of your business finances. This is important for bookkeeping
          completeness and compliance.
        </Text>
      </Dialog.Description>
      <Dialog.Footer className="flex justify-end gap-4">
        <Button onClick={handleCancelClick} variant="link">
          Go Back
        </Button>
        <Button onClick={handleSkipClick} variant="secondary">
          Skip
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
